import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { catchError, of } from 'rxjs';
import {
  FixedTimePeriod,
  RollingTimePeriodKind,
} from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { FiltersStore } from 'src/app/core/stores/filters.store';
import { ServiceInsightsDetailsStore } from '../../stores/service-insights-details.store';
import { ServiceInsightsDetailsKpiCardsData } from '../../types/service-insight-types';

@Component({
    selector: 'service-details-kpi-cards',
    templateUrl: './service-details-kpi-cards.component.html',
    styleUrls: ['./service-details-kpi-cards.component.scss'],
    standalone: false
})
export class ServiceDetailsKpiCardsComponent implements OnInit {
  validPeriod: boolean = true;
  kpiCardsData: ServiceInsightsDetailsKpiCardsData[] = [];
  cardLabel: Partial<Record<RollingTimePeriodKind, string>> = {
    PriorMonth: 'Last Month',
    R3: 'Last 3 Months',
    R6: 'Last 6 Months',
    R12: 'Last 12 Months',
  };

  readonly defaultKpiCards: ServiceInsightsDetailsKpiCardsData[] = [
    {
      period: RollingTimePeriodKind.PriorMonth,
      metricTotal: null,
      percentageChange: null,
    },
    {
      period: RollingTimePeriodKind.R3,
      metricTotal: null,
      percentageChange: null,
    },
    {
      period: RollingTimePeriodKind.R6,
      metricTotal: null,
      percentageChange: null,
    },
    {
      period: RollingTimePeriodKind.R12,
      metricTotal: null,
      percentageChange: null,
    },
  ];

  constructor(
    private _siDetailsStore: ServiceInsightsDetailsStore,
    private _filterStore: FiltersStore,
  ) {}

  ngOnInit(): void {
    const period = this._filterStore.filterSetValue?.Period;
    this.validPeriod =
      period === undefined ||
      (period.$type !== 'FixedTimePeriod' &&
        !(period.$type === 'RollingTimePeriod' && period.Kind === 'YTD'));

    if (this.validPeriod) {
      this._siDetailsStore.kpiCardsData$
        .pipe(
          // Handle any errors that occur while fetching KPI cards data gracefully and provide default values
          catchError((error) => {
            console.error(error);
            return of(this.defaultKpiCards);
          }),
        )
        .subscribe((data) => {
          this.kpiCardsData = data;
        });
    } else {
      this.kpiCardsData = this.defaultKpiCards;
    }
  }
}
